import Axios from 'axios';

const BASE_URL = '/api/reports';


export default {

  getRevenueRpt(data) {
    return Axios.post(BASE_URL + '/revenue', data);
  },
  getExpenseRpt(data) {
    return Axios.post(BASE_URL + '/expense', data);
  },
  getBankingRpt(data) {
    return Axios.post(BASE_URL + '/banking', data);
  },


}



// WEBPACK FOOTER //
// ./resources/assets/js/services/reports.js